import ClosestInteger from 'utils/ClosestInteger.js'
import Constants from 'utils/Constants.js'
import { deleteCookie, getCookie, setCookie } from 'utils/Cookies.js'
import { formatTime } from 'utils/FormatDateTime.js'
import GetBreakpoint from 'utils/GetBreakpoint.js'
import GetViewportSize from 'utils/GetViewportSize.js'
import History from 'utils/History.js'
import { param, deparam } from 'utils/Param.js'
import LoadScript from 'utils/LoadScript.js'
import {
  formatAvailability,
  formatSlotsToDays,
} from 'utils/FormatAvailability.js'
import { formatOpenOrClosed } from 'utils/OpenOrClosed.js'
import { Browser } from 'utils/Browser.js'
import { capitalize, titleCase } from 'utils/Strings.js'

class Utils {
  constructor() {
    this.capitalize = capitalize
    this.closestInteger = ClosestInteger
    this.constants = Constants
    this.deleteCookie = deleteCookie
    this.deparam = deparam
    this.formatAvailability = formatAvailability
    this.formatSlotsToDays = formatSlotsToDays
    this.formatTime = formatTime
    this.getBreakpoint = GetBreakpoint
    this.getViewportSize = GetViewportSize
    this.getCookie = getCookie
    this.history = History
    this.loadScript = LoadScript
    this.formatOpenOrClosed = formatOpenOrClosed
    this.param = param
    this.setCookie = setCookie
    this.titleCase = titleCase
    this.browser = new Browser()
  }

  name() {
    return 'Utils'
  }
}

export default Utils
